import { cx } from '@libs/classnames';
import { seededRandom } from '@libs/random';
import { HorizontalScroll } from '@ui/components/HorizontalScroll';
import { Table, TableCell, TableRow } from '@ui/components/Table';

import tableStyles from './ResultsTable.module.css';
import styles from './ResultsTableSkeleton.module.css';

type Props = {
  rowCount: number;
  roundsCount?: number;
  showElo?: boolean;
};

export function ResultsTableSkeleton({ rowCount, roundsCount = 5, showElo }: Props) {
  const rows = Array.from({ length: rowCount }, (_, i) => i);
  const rounds = Array.from({ length: roundsCount }, (_, i) => i + 1);

  return (
    <HorizontalScroll className={tableStyles.root} enableForDesktop>
      <Table className={tableStyles.table}>
        <TableRow header>
          <TableCell colSpan={2} />
          <TableCell>Имя</TableCell>
          {showElo && (
            <TableCell right rightGap>
              Рейтинг
            </TableCell>
          )}
          {rounds.map((r) => (
            <TableCell key={r}>{r}</TableCell>
          ))}
          <TableCell right className={tableStyles.scoreHeader}>
            &nbsp;
          </TableCell>
        </TableRow>

        {rows.map((i) => (
          <TableRow key={i} hoverable>
            <TableCell
              className={cx(tableStyles.numbers, tableStyles.tableNumber, tableStyles.left)}
            >
              &nbsp;
            </TableCell>
            <TableCell
              className={cx(tableStyles.numbers, tableStyles.seedNumber, tableStyles.left)}
            >
              &nbsp;
            </TableCell>
            <TableCell>
              <div className={tableStyles.titleContainer}>
                <span className={styles.skeleton} style={{ width: 120 + seededRandom(i) * 80 }} />
              </div>
            </TableCell>
            {showElo && (
              <TableCell right rightGap>
                <span className={styles.skeleton} style={{ width: 33 }} />
              </TableCell>
            )}
            {rounds.map((r) => (
              <TableCell key={r} className={tableStyles.result}>
                <div className={styles.skeletonBadge} />
              </TableCell>
            ))}
            <TableCell className={tableStyles.totalScore} right>
              &nbsp;
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </HorizontalScroll>
  );
}
